import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import moment from 'moment';

import MainHeader from './components/header/header.vue';
import SubMenu from './components/common/sub-menu.vue';
import Footer from './components/footer/footer.vue';
import Notifications from './components/notifications/notifications.vue';
import Errors from './components/common/errors.vue';
import ShareOutfitContainer from './components/outfit/share-outfit-container.vue';
import ShareCart from "./components/cart/share-cart.vue";

import styles from './default.scss';

import VueCurrencyFilter from 'vue-currency-filter'
import underscore from 'vue-underscore';
import VeeValidate from 'vee-validate';
import VueLineClamp from 'vue-line-clamp';

/* Global Helper Functions */
import helpers from './helpers/helpers.js';

import ApolloClient from 'apollo-boost';
import VueApollo from 'vue-apollo';

import { PAGES_USING_FILTERS, NON_SCROLLABLE_PAGES } from './config';

const apolloClient = new ApolloClient({
    uri: 'https://the-mada-app.myshopify.com/api/2019-10/graphql.json',
    fetchOptions: {
      credentials: 'include'
    },
    headers: {
      'X-Shopify-Storefront-Access-Token': 'f3e1a08034ef5bf483d84c3ae2e58552',
      'Content-Type': 'application/json'
    }
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.use(VueApollo);

const plugin = {
    install () {
        Vue.helpers = helpers
        Vue.prototype.$helpers = helpers
    }
};

Vue.use(plugin);

Vue.use(VueLineClamp, {
    importCss: true,
});

Vue.component('notifications', Notifications);
Vue.component('errors', Errors);

/* Routes and Store */
import routes from './routes/routes';
import {store} from './store/store';

Vue.component('main-header', MainHeader);
Vue.component('sub-menu', SubMenu);
Vue.component('main-footer', Footer);
Vue.component('share-cart', ShareCart);
Vue.component('share-outfit-container', ShareOutfitContainer);

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VeeValidate);
Vue.use(VueCurrencyFilter,
    {
        symbol: '$',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: false
    });

Vue.use(underscore);

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('MM.DD.YYYY');
    }
});


import {mapGetters} from 'vuex';


Vue.http.interceptors.push((request, next) => {
    if(request.url.search(API_ROOT) === 0) {
        request.headers.set('X-Auth-Token', store.getters['auth/getAuthToken']);
        request.headers.set('Accept', 'application/json');
        request.headers.set('X-App-Version', store.getters['appVersion/getAppVersion']);
    }

    next(function (response) {
        if (response.status == 403) {

        }
    });
})


const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    }
});

router.beforeEach((to, from, next) => {
    //Close profile and search on route change
    store.commit('search/setSearchOpen', {
        searchOpen: to.hash.includes('search-opened')
    });    
    store.commit('menu/setMenuOpen', {
        open: false
    });

    const scrollableEl = window.document.querySelector('.allow-scrolling');
    if(scrollableEl) {
        window.lastSavedScrollPosition = {
            ...(window.lastSavedScrollPosition || {}),
            [from.path]: { x: scrollableEl.scrollLeft, y: scrollableEl.scrollTop },
        };
    }

    // If in signup or login, deactivate scroll
    if(NON_SCROLLABLE_PAGES.some(page => to.path.includes(page))){
        document.getElementById('main-wrapper').classList.remove('allow-scrolling');
    }else{
        document.getElementById('main-wrapper').classList.add('allow-scrolling');
    }
    
    const toUsingFilterPage = PAGES_USING_FILTERS.some(pageUrl => to.path.includes(pageUrl));
    const pageUsingFilter = store.getters['filters/filtersForPage'];

    //Clear filters if switching from filters pages
    if(toUsingFilterPage && pageUsingFilter &&!to.path.includes(pageUsingFilter)) {
        store.commit('filters/resetState');
    }

    //Save the page where the filters will be applied
    if(toUsingFilterPage) {
        store.commit('filters/setFiltersForPage', to.path);
    }

    store.commit(`footer/${to.meta.hideFooter ? 'hide' : 'show'}Footer`, )

    //Check if header is inverted
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to intro page.
        if (!store.getters['auth/getAuthToken']) {
            next({
                path: '/intro',
                query: { redirect: to.fullPath }
            })
        } else {
            store.commit({
                type: 'menu/headerStyle',
                headerStyle: to.meta.headerStyle
            });
            store.commit({
                type: 'menu/setMenuOpen',
                open: false
            });
            next();
        }
    } else {
        store.commit({
            type: 'menu/headerStyle',
            headerStyle: to.meta.headerStyle
        });
        store.commit({
            type: 'menu/setMenuOpen',
            open: false
        });
        next();
    }

    // Set Firebase screen name
    let screenName = to.path.replace('/', '').replace('-', ' ');
    if (typeof window.FirebasePlugin !== 'undefined') {
        window.FirebasePlugin.setScreenName(screenName || 'home');
    }
});

window.app = new Vue({
    router,
    store,
    apolloProvider,
    computed: {
        ...mapGetters({
            headerStyle: 'menu/headerStyle',
            authToken: 'auth/getAuthToken',
            user: 'auth/getUser'
        })
    },
    el: '.vue-mount',
    mounted() {
        if (this.authToken) {
            store.dispatch({
                type: "cart/fetchCartProducts",
            });

            store.dispatch("quizzes/fetchQuizProfile", true);
        }
        store.dispatch({
            type: 'filters/fetchFilters',
        });
        store.dispatch({
            type: "config/fetchCredentials",
        });
        store.dispatch({
            type: 'share/fetchShareData'
        })
    },
    methods:{
        init: function() {
            if (typeof window.FirebasePlugin !== 'undefined') {
                window.FirebasePlugin.grantPermission();
                FirebasePlugin.onTokenRefresh(fcmToken => {
                    store.dispatch('auth/addDeviceToken', {token: fcmToken});
                }, error => {
                });
                window.FirebasePlugin.setAnalyticsCollectionEnabled(true);
                if (this.user.user_id) {
                    window.FirebasePlugin.setUserId(this.user.user_id);
                }
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('keyboardWillShow');
        window.removeEventListener('keyboardWillHide');
    },
});

document.addEventListener('deviceready', window.app.init);
